module.exports = __webpack_public_path__ + "static/media/gcp_logo.50a99bd6.svg";